export default {
  title: '素材庫',
  tabImage: '圖片',
  tabVideo: '影片',
  upload: '上傳圖片',
  uploadVideo: '上傳影片',
  batchGroup: '批次移動',
  batchDelete: '批次刪除',
  selected: '已選',
  item: '項',
  cancelSelect: '取消選擇',
  searchNamePlaceholder: '按名稱搜尋',
  uploadNow: '立即上傳',
  editTitle: '編輯素材',
  materialName: '素材名稱',
  materialNamePlaceholder: '請輸入素材名稱',
  moveGroupTitle: '移動分組',
  targetGroup: '目標分組',
  selectGroupPlaceholder: '請選擇分組',
  confirmDeleteSingle: '確定要刪除該素材嗎？',
  confirmDelete: '確定要刪除選中的素材嗎？',
  emptyImage: '暫無圖片',
  emptyVideo: '暫無影片',
};
